module.exports = __webpack_public_path__ + "static/guard01-f1a0c34047b67d3b2c340c40ea226a63.jpg";